import React from 'react';
import { Form, Input, Select, Checkbox, Tree, Row, Col, message, InputNumber } from 'antd';
import ModalDom from '../../../../components/Modal';
import CuttingLine from '../../../../components/CuttingLine';
import { post, postFrom, config } from '../../../../axios';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import {  dicMerchantDepartmentStatus } from '../../../../axios/dictionaries';
import DetailTitle from '../../../../components/DetailTitle';

const FormItem = Form.Item;
const Option = Select.Option;
const CheckboxGroup = Checkbox.Group;
const { TreeNode } = Tree;

class Page extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            params: {
                departmentId: '', //部门id
                loginFailTimes: '',
                loginIp: '',
                loginKey: '',
                loginToken: '',
                name: '', //姓名
                phone: '', //手机
                roleIds: '', //岗位
                status: '', //状态
            },
            id: '',
            data: {},
            title: '新增人员', //标题名称
            inputWidth: 160,
            roleLists: [], //岗位列表容器
            checkedKeys: [], //选中的房源
            passwordType: 'password', //新增|编辑类型
            shouldPasswordRequired: true, //密码是否必输
            jurisdictionData: [], //数据权限
        }

    }

    render() {
        let { visible, optionData, form: { getFieldDecorator } } = this.props;
        let { loading,
            data,
            title,
            inputWidth,
            roleLists,
            checkedKeys,
            passwordType,
            shouldPasswordRequired,
            jurisdictionData,
        } = this.state;

        return <ModalDom
            title={title}
            visible={visible}
            width={"800px"}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="custom" style={{
                marginTop: '-18px'
            }}>
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                    className="min-height"

                >
                    <DetailTitle title="基本信息" />
                    <Row>
                        <Col span={24}>
                            <CustomRow>
                                <CustomCol label="姓名">
                                    {getFieldDecorator('name', {
                                        rules: [{
                                            required: true, message: '请输入姓名',
                                        }],
                                        initialValue: data.name
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="部门">
                                    {getFieldDecorator('departmentId', {
                                        rules: [{
                                            required: true, message: '请选择部门',
                                        }],
                                        initialValue: data.departmentId
                                    })(
                                        <Select
                                            showSearch
                                            
                                            placeholder="请选择"
                                            onChange={(value) => { //切换部门
                                                // if (value === data.buildingId) {
                                                //     setFieldsValue({ layout: data.layout, floor: data.floor });
                                                // } else {
                                                //     setFieldsValue({ layout: undefined });
                                                // }
                                                //this.loadBuildingDetail({ buildingId: value });
                                                //this.initPack(f)
                                                console.log("部门Id=>"+value);
                                                this.initPack(true,value);
                                               // this.loadRoomTypeList(value)
                                            }}
                                            optionFilterProp={'children'}
                                        >
                                            {optionData.map((item, index) => {
                                                if (item.status == 1) {
                                                    return (<Option key={index} value={item.value}>{item.title}</Option>)
                                                }
                                            })}
                                        </Select>
                                    )}
                                </CustomCol>
                
                            </CustomRow>

                            <CustomRow divider>
                                <CustomCol label="手机">
                                    {getFieldDecorator('phone', {
                                        rules: [{
                                            required: true, message: '请输入手机',
                                        }],
                                        initialValue: data.phone
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>

                                <CustomCol required={shouldPasswordRequired ? undefined : false} label="密码">
                                    {getFieldDecorator(passwordType, {
                                        rules: [{
                                            required: shouldPasswordRequired, message: '请输入密码',
                                        }],
                                    })(
                                        <Input
                                            type={'password'}
                                            placeholder={'请输入'}
                                            
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>



                            <CustomRow divider>
                                <CustomCol label="状态">
                                    {getFieldDecorator('status', {
                                        rules: [{
                                            required: true, message: '请选择状态',
                                        }],
                                        initialValue: data.status || 1
                                    })(
                                        <Select
                                            showSearch
                                            
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                        >
                                            {dicMerchantDepartmentStatus.map((item, index) => <Option key={index} value={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>

                                <CustomCol label="分配岗位">

                                    {getFieldDecorator('roleId', {
                                        rules: [{
                                            required: true,
                                            message: '请选择分配岗位'
                                        }],
                                        initialValue: data.roleId
                                    })(
                                        <Select
                                            showSearch
                                            
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                        >
                                            {roleLists.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="顾问账号"  required={false}>
                                    {getFieldDecorator('guideAccount', {
                                        rules: [{
                                            required: false, message: '请输入微信顾问账号',
                                        }],
                                        initialValue: data.guideAccount
                                    })(
                                        <Input
                                            placeholder={'请输入微信顾问账号'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>

                                <CustomCol label="顾问openId" required={false}>
                                    {getFieldDecorator('guideOpenid', {
                                        rules: [{
                                            required: false, message: '请输入微信顾问openid',
                                        }],
                                        initialValue: data.guideOpenid
                                    })(
                                        <Input
                                            placeholder={'请输入微信顾问openid'}

                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>


                            </CustomRow>

                        </Col>
                    </Row>

                    <DetailTitle title="数据权限" />
                    {
                        jurisdictionData.length
                            ? <Tree
                                // loadData={this.onLoadData}
                                multiple
                                checkable
                                onCheck={
                                    (checkedKeys) => {
                                        this.setState({ checkedKeys });
                                    }
                                }
                                checkedKeys={checkedKeys}
                                style={{
                                    maxHeight: "200px",
                                    overflowY: "scroll"
                                }}
                            >
                                {this.renderTreeNodes(jurisdictionData)}
                            </Tree>
                            : <div style={{ textAlign: 'center' }}>暂无数据</div>
                    }

                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    handleCancel = () => {
        this.props.handleCancel();
        this.setState({ data: {}, loading: false, title: "新增人员", checkedKeys: [], jurisdictionData: [] })
        this.defaultcheckedKeys = [];
    }

    defaultcheckedKeys = []

    initPack(newAdd,departmentId) {

        this.setState({ loading: true });
        departmentId=departmentId?departmentId:0;
        if(departmentId==0) {
            if (newAdd) {
                this.setState({passwordType: 'password', shouldPasswordRequired: true})
            } else {
                this.setState({passwordType: 'passwordNew', shouldPasswordRequired: false})
            }
        }




        postFrom({
            url: config.API_employeedataauthority_findMerchantAndProject,
            data: {id:departmentId}
        }).then(res => {
            let arr = [];
            arr = res.merchants.map((item, index) => {
                item.idDispose = 'merchant' + item.id;
                item.title = item.shortName;
                item.children = res.projects.filter((item2, index) => {
                    item2.idDispose = `project${item2.id},${item2.merchantId}`;
                    item2.title = item2.name;
                    return item.id === item2.merchantId
                })
                if(item.children.length === 0){
                    item.disabled = true
                }
                return item
            })

            this.setState({ jurisdictionData: arr, loading: false });
        }).catch(err => {
            message.error(err.message || '获取商户项目列表失败');
            this.setState({ loading: false });
        });

    }

    loadPack = ({ id }) => {
        this.setState({ loading: true, title: "编辑人员", id });

        let data = { employeeId: id };
        postFrom({
            url: config.API_employee_getById,
            data,
        }).then(res => {
            let checkedKeys = [];
            checkedKeys = res.employeeDataAuthority.map((item, index) => {
                return `project${item.projectId},${item.merchantId}`;
            });
            this.defaultcheckedKeys = res.employeeDataAuthority; //当前已被选中的项目
            this.setState({ data: res, loading: false, checkedKeys });
            this.initPack(false,res.departmentId)
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        })
    }

    loadRole = () => { //岗位列表查询

        this.setState({ loading: true });
        postFrom({
            url: config.API_role_findAll, //应为岗位列表接口
            data: { owner: 1 }
        }).then(res => {
            let result = res.filter(item => item.status == 1)
            this.setState({ roleLists: result, loading: false });
        }).catch(err => {
            message.error(err.message || '获取岗位列表失败');
            this.setState({ loading: false });
        })
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {

            this.setState({ loading: true });

            let data = {},
                NOW_URL = '',
                responText = '',
                { params, id, checkedKeys } = this.state;
            let employeeDataAuthority = [];
            for (let i = 0; i < checkedKeys.length; i++) {
                if (checkedKeys[i].startsWith('project')) {
                    let checkHandle = checkedKeys[i].slice(7).split(',');
                    employeeDataAuthority.push({ merchantId: checkHandle[1], projectId: checkHandle[0] })
                }
            }
            for (let i = 0; i < employeeDataAuthority.length; i++) {
                let item = this.defaultcheckedKeys.find((item, index) => {
                    return item.projectId === +employeeDataAuthority[i].projectId
                })
                if (item) {
                    employeeDataAuthority[i].id = item.id;
                }
            }

            values.employeeDataAuthority = employeeDataAuthority;
            data = Object.assign({}, params, values);



            if (this.props.handlecreateOrEdit) {
                NOW_URL = config.API_employee_edit;
                responText = '编辑'
                data.id = id;
            } else {
                NOW_URL = config.API_employee_create;
                responText = '新增'
            }
            post({
                url: NOW_URL,
                data,
            }).then(res => {

                this.setState({ loading: false, checkedKeys: [], jurisdictionData:[] });
                this.props.handleGetList();
                this.handleCancel();
                message.success(`${responText}成功`);
            }).catch(err => {
                message.error(err.message || '接口异常');
                this.setState({ loading: false })
            }
            )
        })
    }

    renderTreeNodes = data => {
        return data.map(item => {
            if (item.children) {
                return (
                    <TreeNode disableCheckbox={item.disabled} selectable={false} title={item.title} key={item.idDispose} dataRef={item}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode selectable={false} title={item.title} key={item.idDispose} dataRef={item} isLeaf={item.isChild} />;
        })
    }

}

export default Form.create()(Page);



// WEBPACK FOOTER //
// ./src/page/Employee/components/ManageAdd/index.js